import { WizardFixedCostValues } from '../../../types';

export const FIXED_COST_FIELDS: Array<{
  key: keyof WizardFixedCostValues;
  label: string;
}> = [
  { key: 'landRent', label: 'Land Rent' },
  { key: 'equipment', label: 'Equipment' },
  { key: 'labor', label: 'Labor' },
  { key: 'repairs', label: 'Repairs' },
  { key: 'taxes', label: 'Taxes' },
  { key: 'insurance', label: 'Insurance' },
  { key: 'returnToMgt', label: 'Return to Management' }
];

export const calculateTotalFixedCost = (
  fixedCost: WizardFixedCostValues
): number =>
  FIXED_COST_FIELDS.reduce(
    (sum, { key }) => sum + (Number(fixedCost?.[key]) || 0),
    0
  );
